import { useState } from 'react';
import { api } from '../utils/api';
import { ENV } from '../config/env';

// Helper function to convert VAPID key for browser compatibility
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export const usePushNotifications = () => {
  const [permission, setPermission] = useState(
    typeof Notification !== 'undefined' ? Notification.permission : 'default'
  );

  const subscribe = async () => {
    if (!('serviceWorker' in navigator) || typeof Notification === 'undefined') {
      console.warn('Push notifications not supported in this environment.');
      return;
    }

    try {
      const registration = await navigator.serviceWorker.ready;
      
      // Request permission
      const perm = await Notification.requestPermission();
      setPermission(perm);

      if (perm === 'granted') {
        const vapidPublicKey = ENV.VAPID_PUBLIC_KEY;
        
        if (!vapidPublicKey) {
          throw new Error('VAPID public key is missing from config/env.js.');
        }

        // Subscribe to push service with correctly formatted key
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
        });

        // Send subscription to backend
        await api.post('/notifications/subscribe', subscription);
        console.log('Push notification subscribed successfully!');
      }
    } catch (error) {
      console.error('Failed to subscribe to push notifications:', error);
    }
  };

  return { permission, subscribe };
};
